import { render, staticRenderFns } from "./RoundWinLoseTop.vue?vue&type=template&id=67007ac3&scoped=true&"
import script from "./RoundWinLoseTop.vue?vue&type=script&lang=js&"
export * from "./RoundWinLoseTop.vue?vue&type=script&lang=js&"
import style0 from "./RoundWinLoseTop.vue?vue&type=style&index=0&id=67007ac3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67007ac3",
  null
  
)

export default component.exports